// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"c031e9ea","171":"9d1c3db6","210":"2fd01a2a","432":"d2484486","507":"f13b5646"}[chunkId] + ".chunk.js";
};